export enum FeeActiveLabel {
  active = "Active",
  inactive = "Inactive",
  willBeActive = "Will be active",
  willBeInactive = "Will be inactive",
  previouslyActive = "Previously active",
  previouslyInactive = "Previously inactive"
}
